import { TranslationKey } from './../translation/TranslationKey';

import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity, forCreate, forDelete, forUpdate } from '../common/entity';
import { TableSettingsColumn } from '../tableSettings';
import { t } from '../translation/Translator';

export enum KitTemplateColumn {
  name = 'name',
  delete = 'delete',
}

export class KitTemplateTableSettings extends CompanyEntity {
  columns: KitTemplateTableColumn[] = defaultKitTemplateTable;
  userId?: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }

  forUpdate(): UpdateKitTemplateTableSettingsInput {
    return UpdateKitTemplateTableSettingsInput.from(this, UpdateKitTemplateTableSettingsInput);
  }

  forDelete(): DeleteKitTemplateTableSettingsInput {
    return DeleteKitTemplateTableSettingsInput.from(this, DeleteKitTemplateTableSettingsInput);
  }

  validate() {
    return this.validateEntity(
      Object.getOwnPropertyNames(this) as (keyof KitTemplateTableSettings)[],
      (field: keyof KitTemplateTableSettings) => {
        return null;
      },
    );
  }
}

export class CreateKitTemplateTableSettingsInput extends forCreate(KitTemplateTableSettings) {}

export class UpdateKitTemplateTableSettingsInput extends forUpdate(KitTemplateTableSettings) {}

export class DeleteKitTemplateTableSettingsInput extends forDelete(KitTemplateTableSettings) {}

export class KitTemplateTableColumn implements TableSettingsColumn<KitTemplateColumn> {
  index: number;
  column: string;
  label: string;

  constructor(index: number, column: string, label: string) {
    this.index = index;
    this.column = column;
    this.label = label;
  }
}

export const defaultKitTemplateTable: KitTemplateTableColumn[] = [
  {
    index: 0,
    column: KitTemplateColumn.name,
    label: t(TranslationKey.name).singular.label,
  },
];

export function kitTemplateColumnToString(col: string) {
  switch (col) {
    case KitTemplateColumn.name:
      return t(TranslationKey.name).singular.label;
    case KitTemplateColumn.delete:
      return t(TranslationKey.delete).singular.label;
  }
  return col;
}

export function stringToKitTemplateColumn(col: string) {
  switch (col) {
    case t(TranslationKey.name).singular.label:
      return KitTemplateColumn.name;
    case t(TranslationKey.delete).singular.label:
      return KitTemplateColumn.delete;
  }
  return col;
}
